import axios from 'axios'

// Configure axios defaults
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor for handling common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response || {}

    if (status === 401) {
      // Handle unauthorized - clear token and redirect to login
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user_data')
      window.location.href = '/login'
    }

    return Promise.reject(error)
  }
)

// Xuất apiClient để sử dụng trực tiếp nếu cần
export { apiClient }

export default {
  // Auth services
  auth: {
    login(credentials) {
      return apiClient.post('/auth/login', credentials)
    },
    register(userData) {
      return apiClient.post('/auth/register', userData)
    },
    getProfile() {
      return apiClient.get('/user/profile')
    },
    updateProfile(profileData) {
      return apiClient.put('/user/profile', profileData)
    },
    changePassword(passwordData) {
      return apiClient.post('/auth/change-password', passwordData)
    }
  },

  // Device services
  devices: {
    getAll(params = {}) {
      return apiClient.get('/devices', { params })
    },
    getById(id) {
      return apiClient.get(`/devices/${id}`)
    },
    create(data) {
      return apiClient.post('/devices', data)
    },
    update(id, data) {
      return apiClient.put(`/devices/${id}`, data)
    },
    delete(id) {
      return apiClient.delete(`/devices/${id}`)
    },
    updateStatus(id, status) {
      return apiClient.put(`/devices/${id}/status`, { status })
    }
  },

  // Component services
  components: {
    getByDeviceId(deviceId) {
      return apiClient.get(`/devices/${deviceId}/components`)
    },
    getById(deviceId, id) {
      return apiClient.get(`/devices/${deviceId}/components/${id}`)
    },
    create(deviceId, data) {
      return apiClient.post(`/devices/${deviceId}/components`, data)
    },
    update(deviceId, id, data) {
      return apiClient.put(`/devices/${deviceId}/components/${id}`, data)
    },
    delete(deviceId, id) {
      return apiClient.delete(`/devices/${deviceId}/components/${id}`)
    },
    updateData(deviceId, id, data) {
      return apiClient.put(`/devices/${deviceId}/components/${id}/data`, { data })
    }
  },

  // Component Schedule services
  schedules: {
    getByComponentId(deviceId, componentId, params = {}) {
      return apiClient.get(`/devices/${deviceId}/components/${componentId}/schedules`, { params })
    },
    getById(deviceId, componentId, id) {
      return apiClient.get(`/devices/${deviceId}/components/${componentId}/schedules/${id}`)
    },
    create(deviceId, componentId, data) {
      return apiClient.post(`/devices/${deviceId}/components/${componentId}/schedules`, data)
    },
    update(deviceId, componentId, id, data) {
      return apiClient.put(`/devices/${deviceId}/components/${componentId}/schedules/${id}`, data)
    },
    delete(deviceId, componentId, id) {
      return apiClient.delete(`/devices/${deviceId}/components/${componentId}/schedules/${id}`)
    },
    getState(deviceId, componentId) {
      return apiClient.get(`/devices/${deviceId}/components/${componentId}/state`)
    },
    applyOverride(deviceId, componentId, data) {
      return apiClient.post(`/devices/${deviceId}/components/${componentId}/override`, data)
    },
    removeOverride(deviceId, componentId) {
      return apiClient.delete(`/devices/${deviceId}/components/${componentId}/override`)
    },
    translateCron(expression) {
      return apiClient.post('/devices/translate-cron', { expression })
    }
  },

}
